import { CheckBoxOutlined, CheckBoxOutlineBlank } from "@mui/icons-material";
import { FormControl, FormControlLabel, FormGroup, FormLabel } from "@mui/material";

import Box from "../Box";
import CheckBox from "../CheckBox";
import Typography from "../Typography";
import Helpers from "../../commons/helpers";

import { Mode } from "../../constants/enums";
import { ICodename } from "../../commons/interfaces";

interface IProps {
    mode?: Mode;
    value: any;
    label: string;
    isRow?: boolean;
    isMulti?: boolean;
    disabled?: boolean;
    dataMulti?: ICodename[];
    onChangeValue?: (value: any) => void;
}

const ControlLabelCheckBox: React.FC<IProps> = (props: IProps) => {
    if ((props.mode === Mode.View) && !props.isMulti) {
        return (
            <Box display="flex" alignItems="center">
                {
                    (props.value === true)
                        ? <CheckBoxOutlined /> : <CheckBoxOutlineBlank />
                }
                <Typography variant="button">
                    &ensp;{props.label}
                </Typography>
            </Box>
        );
    }

    const handleChangeValue = (event: any, checked: boolean) => {
        if (Helpers.isFunction(props.onChangeValue)) {
            let valTemp: any[] = [...props.value || []];
            if (checked) {
                valTemp.push(event.target?.value);
            } else {
                valTemp = valTemp.filter(val => val != event.target?.value);
            }
            props.onChangeValue(valTemp);
        }
    }

    return (props.isMulti
        ? (
            <FormControl>
                <FormLabel component="legend">
                    <Typography color="secondary" variant="caption" fontWeight="regular" sx={{ lineHeight: 0, fontSize: "0.825rem" }}>
                        {props.label}
                    </Typography>
                </FormLabel>
                <FormGroup
                    row={props.isRow}
                    style={{ width: "fit-content" }}
                >
                    {
                        [...props.dataMulti || []].map((item, index) => (
                            <FormControlLabel
                                key={index}
                                label={item.name}
                                value={item.code}
                                control={<CheckBox />}
                                disabled={props.disabled}
                                onChange={handleChangeValue}
                                sx={{ mb: 0, mt: 0, ml: 0, fontWeight: 400 }}
                            />
                        ))
                    }
                </FormGroup>
            </FormControl>
        )
        : (
            <FormGroup style={{ width: "fit-content" }}>
                <FormControlLabel
                    label={props.label}
                    disabled={props.disabled}
                    sx={{ mb: 0, mt: 0, ml: 0 }}
                    key={(props.value as any) || props.label}
                    control={
                        <CheckBox
                            checked={props.value}
                            onChange={(event: any, checked: boolean) => {
                                if (props.onChangeValue && Helpers.isFunction(props.onChangeValue)) {
                                    props.onChangeValue(checked);
                                }
                            }}
                        />
                    }
                />
            </FormGroup>
        )
    );
};

export default ControlLabelCheckBox;
